// extracted by mini-css-extract-plugin
module.exports = {"UserSettingsPage":"UserSettingsPage_UserSettingsPage__2cpjJ","PageHeader":"UserSettingsPage_PageHeader__1opWR","Card":"UserSettingsPage_Card__Pn_NW"};